jQuery(document).ready(function () {
    setTimeout(function() {
        //jQuery('.product-gallery__thumbnail.one-fifth.column:nth-child(3) img').click();
    }, 500);
    jQuery('.quick-buy-detail .button--add-to-cart').removeClass('action_button--secondary');

  jQuery('.quick-buy-detail .purchase-details__buttons').removeClass('purchase-details__spb--true');
  // jQuery('.quick-buy-bttn').each(function(){
  //   // var _this = this;
  //   // jQuery(document).on('mouseover','.quick-buy-bttn', function() {
  //      var product_price = jQuery(this).parents('.ha-product-info').find('.product-thumbnail__price.price .money').text();
  //       jQuery(this).find('.addtocart-div .wc-price').remove();
  //       jQuery(this).find('.purchase-details .wc-price').remove();
  //       jQuery(this).find('.quick-buy-detail .addtocart-div').append('<div class="wc-price"><div class="wc-product-price">'+product_price+'</div></div>');
  //       jQuery(this).find('.quick-buy-detail .purchase-details').append('<div class="wc-price"><div class="wc-product-price">'+product_price+'</div></div>');
  //   });
    function customATCClick(){
      $('.addtocart-div, .purchase-details').click(function(event){ event.stopPropagation(); $(this).find(".button--add-to-cart")[0].click();});
  }
  jQuery(document).on('mouseover','.quick-buy-bttn', function() {
    if(!jQuery(this).find('.quick-buy-detail .addtocart-div .wc-price .wc-product-price').length > 0){
        let moneyPrices = jQuery(this).parents('.ha-product-info').find('.product-thumbnail__price.price .money');
        var product_price = moneyPrices.text();
        if(moneyPrices.length > 1) {
          product_price = '<p><span class="price">' + jQuery(moneyPrices[0]).text() + '</span>';
          product_price += '<span class="discounted-price">' + jQuery(moneyPrices[1 ]).text() + '</span></p>';
        }
        
        jQuery(this).find('.addtocart-div .wc-price').remove();
        jQuery(this).find('.purchase-details .wc-price').remove();
        jQuery(this).find('.quick-buy-detail .addtocart-div').append('<div class="wc-price"><div class="wc-product-price">'+product_price+'</div></div>');
        jQuery(this).find('.quick-buy-detail .purchase-details').append('<div class="wc-price"><div class="wc-product-price">'+product_price+'</div></div>');
    }
    // Comment due to fix add to cart issue
    // customATCClick();
  });

  jQuery('.quick-buy-detail variant-selection [data-variant-option-chosen-value]').on('change', function() {
      console.log('Clicked addded to cart variant');
      jQuery(this).parents('form').find('button[type=submit]').trigger('click');
      // search selected variant and make add to bag concept
      const selectorEle = jQuery(this).find('.swatch-element[data-value="'+ jQuery(this).attr('data-variant-option-chosen-value') +'"]');
      selectorEle.addClass('added');
      selectorEle.append('<span class="partially-added">Added to Cart</span>');
      setTimeout(function() {
        selectorEle.removeClass('added');
        selectorEle.find('.partially-added').remove();
      }, 2000);
  });
  
  jQuery(document).on('click','.addtocart-div',function(){
    jQuery(this).parents('form').find('input[type=submit]').trigger('click');
  });

    jQuery(document).on('click','.product-app .jdgm-widget',function(){
        jQuery('html,body').animate({
          scrollTop: jQuery(".product-app--container").offset().top - 200},
          'slow');
    });

  /*jQuery(document).on('change','.bsub-widget__plan input',function(){
     console.log(jQuery(this).attr('data-title'));
});*/
  /**
   * Upcart events to manage product title@13.02.23
   * Help: https://aftersell.notion.site/UpCart-Public-API-7a0f6d75cb044871bdb6da5d99cfc755
   */
  function waitForElement(elementPath, callBack){
    window.setTimeout(function(){
      if($(elementPath).length){
        callBack(elementPath, $(elementPath));
      }else{
        waitForElement(elementPath, callBack);
      }
    },500)
  }
  /**
  * Redesign cart upsell product
  */
  function redesignUpsellProducts() {
    $('h3.upcart-upsell-item-title').each(function() {
      let pTitle = $(this).html();
      if(pTitle) {
        let pTitleArr = pTitle.split('|');
        if(pTitleArr.length > 1) {
          pTitle = pTitleArr[0];
          pTitle += '<span>' + pTitleArr[1] + '</span>';
        }
        $(this).html(pTitle);
      }
    });
  }
  /**
  * Redesign cart item
  */
  function redesignCartItem() {
    $('h3.upcart-product-title').each(function() {
      let pTitle = $(this).find('a').html();
      if(pTitle) {
        let pTitleArr = pTitle.split('|');
        if(pTitleArr.length > 1) {
          pTitle = pTitleArr[0];
          pTitle += '<span>' + pTitleArr[1] + '</span>';
        }
        $(this).find('a').html(pTitle);
      }
    });
  }
  window.upcartOnCartOpened = function() {
    // Redesign cart item
    if($('h3.upcart-product-title').length <= 0) {
      waitForElement('h3.upcart-product-title',function(){
        redesignUpsellProducts();
      });
    } else {
      redesignCartItem();
    }
    // Redesign cart upsell product
    if($('h3.upcart-upsell-item-title').length <= 0) {
      waitForElement('h3.upcart-upsell-item-title',function(){
        redesignUpsellProducts();
      });
    }
    redesignUpsellProducts();
    setTimeout(function() {
      redesignUpsellProducts();
    }, 1200);
  }
  $(document).ajaxComplete(function() {
    redesignUpsellProducts();
    setTimeout(function() {
      redesignUpsellProducts();
    }, 2000);
  });
  window.upcartOnCartLoaded = function() {
    redesignUpsellProducts();
    setTimeout(function() {
      redesignUpsellProducts();
    }, 1200);
  }
  window.upcartOnCartUpdated = function() {
    // redesignUpsellProducts();

     $('h3.upcart-product-title').each(function() {
      let pTitle = $(this).html();
      if(pTitle) {
        let pTitleArr = pTitle.split('|');
        if(pTitleArr.length > 1) {
          pTitle = pTitleArr[0];
          pTitle += '<span>' + pTitleArr[1] + '</span>';
        }
        $(this).html(pTitle);
      }
    });


    $(".upcart-product-item").each(function(){
  var valueText = $(this).find(".upcart-item-option-value").text();
   // console.log("valueText",valueText);
   var arr = valueText.split('-');
 $(this).find(".upcart-item-option-value").html("<span>"+arr[0] + "</span>");     
 });
    // setTimeout(function() {
    //   redesignUpsellProducts();
    // }, 1200);
  }
  $(".upcart-product-item").each(function(){
  var valueText = $(this).find(".upcart-item-option-value").text();
   // console.log("valueText",valueText);
   var arr = valueText.split('-');
 $(this).find(".upcart-item-option-value").html("<span>"+arr[0] + "</span>");     
 });
  /**
   * Upcart events to manage product count on remove item@15.02.23
   * Help: https://aftersell.notion.site/UpCart-Public-API-7a0f6d75cb044871bdb6da5d99cfc755
   */
  window.upcartOnItemRemoved = function(itemKey, item) {
    console.log('Removed', itemKey, item);
    const removedQty = item.quantity;
    const currentQty = parseInt($('[data-bind="itemCount"]').html());
    let totalQty = 0;
    if(currentQty >= removedQty) {
      totalQty = currentQty - removedQty;
    }
    if(totalQty <= 0) {
      $('.header-cart.action-area__link.has-cart-count').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').html('0')
    } else {
      $('[data-bind="itemCount"]').html(totalQty);
    }
    
    
  }
  /**
   * FAQ Search button
   */
  $.expr[':'].contains = function(a, i, m) {
    return $(a).text().toUpperCase()
        .indexOf(m[3].toUpperCase()) >= 0;
  };
  $('input[data-search][type=search]').on('search', function() {
    const searchText = $(this).val();
    
    if(searchText.length < 2) {
      $('.accordion-container h4').removeClass('hidden');
      $('.accordion-container .shopify-section').removeClass('hidden');

    }
  });
  $('input[data-search][type=search]').on('input', function() {
    const searchText = $(this).val();
    
    if(searchText.length < 2) {
      $('.accordion-container h4').removeClass('hidden');
      $('.accordion-container .shopify-section').removeClass('hidden');

    }
  });
  $('input[data-search][type=search]').on('keyup', function() {
    const searchText = $(this).val();
    
    if(searchText.length > 2) {
      $('.accordion-container h4:not(:contains("'+searchText+'"))').each((currIndex, curr) => {
        $(curr).addClass('hidden');
      });
    } else {
      $('.accordion-container h4').removeClass('hidden');
      $('.accordion-container .shopify-section').removeClass('hidden');
    }
    $('.accordion-container .shopify-section').each((currentIndex, currSec) => {
        const currentSection = $(currSec).find('h2');
        if($(currSec).find('h4').length == $(currSec).find('h4.hidden').length) {
            $(currSec).addClass('hidden');
        } else {
            $(currSec).removeClass('hidden');
        }
    });
    // $('.accordion-container p:not(:contains("'+searchText+'"))').each((currIndex, curr) => {
    //     $(curr).addClass('hidden');
    // });
  });
  /**
   * Subscription in product page
   */
  if($('.dropp-header__title.js-value').length > 0) {
    $('.dropp-header__title.js-value').on('click', function() {
      $(this).parent().find('a').trigger('click');
    });
  }

  if($('a[href="#faq-block1"]')) {
    $('a[href="#faq-block1"]').on('click', function() {
      $('a[name=faq-block1]').parent().addClass('custom-pad-scroll');
    });
    window.onscroll = function(e) {
      if($("#shopify-section-faq-our-story-section").length > 0) {
        if(this.oldScroll > this.scrollY) {
          if($(window).scrollTop() < $("#shopify-section-faq-our-story-section").offset().top) {
            $('a[name=faq-block1]').parent().removeClass('custom-pad-scroll');
          }
        }
      }
      this.oldScroll = this.scrollY;
    }
  }
  
   // Ketul TODO 28/12/2023
  // swiper slider for individual page Other Naak PRO Runners section
    var $status = $('.pagingInfo');
    var $slickElement = $('.pro-runners-slider');

    $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        // $status.text(i + '/' + slick.slideCount);
        $status.html( '<span class="current_slide">' + i + '</span> | <span class="total_slides"> ' + slick.slideCount + '</span>');
    });
    $slickElement.slick({
      slidesToShow: 4,
      arrows: true,
      infinite: true,
      dots: false,
      // prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa-solid fa-chevron-left'></i></button>",
      // nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa-solid fa-chevron-right'></i></button>",
      prevArrow:".custom_image_slider .test-prev",
      nextArrow:".custom_image_slider .test-next",
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            slidesToShow: 2,
            dots: true,
          },
        },
      ],
    });
    // slick photo gallery
  
    
    function checkSlider() {
    if (window.innerWidth >= 768){
    var $status1 = $('.pagingInfo1');
    var $slickElement1 = $('.photo-gallery-slider:not(.slick-initialized)');

    $slickElement1.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var j = (currentSlide ? currentSlide : 0) + 1;
        // $status1.text(i + '/' + slick.slideCount);
        $status1.html( '<span class="current_slide">' + j + '</span> | <span class="total_slides"> ' + slick.slideCount + '</span>');
    });
     $slickElement1.slick({
      centerMode: true,
      slidesToShow: 3,
      arrows: true,
      infinite: true,
      dots: false,
      // prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa-solid fa-chevron-left'></i></button>",
      // nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa-solid fa-chevron-right'></i></button>",
      prevArrow:".custom-photo-gallery .test-prev1",
      nextArrow:".custom-photo-gallery .test-next1"
      /*responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            centerMode: true,
            centerPadding: "40px",
            slidesToShow: 2,
          },
        } ,
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            centerMode: true,
            centerPadding: "40px",
            slidesToShow: 1,
          },
        }, 
      ],*/
    });
    $('.photo-gallery-button').removeClass('hidden');
  }
      else{
        $('.photo-gallery-slider.slick-initialized').slick("unslick");
        $('.photo-gallery-button').addClass('hidden');
      }
    }
    checkSlider();

    $(window).resize(function(){
      checkSlider();
    });
  /* IMAGE WITH TEXT VIDEO OPTION */

  $('.image-with-text__image-column .video-wrapper').on('click', function(){
    if($('.test_video').length){
      var video = $(this).closest( ".image-with-text__image-column" ).find("video");
      video[0].play();
    $('#btn_play').addClass('hidden');
    }
    else{
      $(".video-wrapper .lazyframe .js-youtube")[0].src += "&autoplay=1";
      ev.preventDefault();
    }
  });
  
  if(!$('.test_video').length){
    $('.video-wrapper').addClass('section_you_video');
    console.log("hello.....");
    $('#btn_play').addClass('hidden');
  }
  // magnificPopup using display you tube video on product page
 $('.video-popup').magnificPopup({
            type: 'iframe',
           iframe: {
              patterns: {
                youtube: {
                  index: 'youtube.com/', 
                  id: 'v=',
                  src: 'https://www.youtube.com/embed/%id%?autoplay=1&mute=1' // Added autoplay=1 and mute=1
                }
              }
            }
        });
});


// announcement bar swiper
document.addEventListener("DOMContentLoaded", function () {
    const announcementSwiper = new Swiper('.announcement-swiper', {
      loop: true,
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });

// end of announcement bar swiper

///  scroll top to show the heading also on click on enter now

$(function() {
  $('.buttons.is-left .button').click(function(event) {
    const targetOffset = $('.klaviyo-form.klaviyo-form.klaviyo-form').offset().top;
    console.log("targetOffset >>> ",targetOffset);
    const offsetAdjustment = 100;

    $('html, body').animate({
        scrollTop: targetOffset - offsetAdjustment, // Scroll to adjusted position
      },800);
  });
});
/// end of scroll top to show the heading also on click on enter now